function QuickCreateCard({ title, icon: Icon, bgColor = 'bg-blue-50' }) {
  return (
    <button
      className={`${bgColor} p-6 rounded-lg text-left hover:shadow-md transition-shadow w-full`}
    >
      <div className="flex items-start space-x-3">
        <div className="flex-shrink-0">
          <Icon className="h-6 w-6 text-gray-900" />
        </div>
        <span className="text-sm font-medium text-gray-900">+ {title}</span>
      </div>
    </button>
  );
}

export default QuickCreateCard;